<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('clinic_id')}" id="clinic_id"
					formControlName="clinic_id" placeholder="">
				<label for="clinic_id">Prefix*</label>
			</div>
			<p *ngIf="showError('clinic_id')" class="text-danger">
				<span *ngIf="f.clinic_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.clinic_id.errors?.incorrect">
					{{customError.clinic_id}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('clinic_name')}" id="clinic_name"
					formControlName="clinic_name" placeholder="">
				<label for="clinic_name">Clinic Name*</label>
			</div>
			<p *ngIf="showError('clinic_name')" class="text-danger">
				<span *ngIf="f.clinic_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.clinic_name.errors?.incorrect">
					{{customError.clinic_name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('email_id')}" id="email_id"
					formControlName="email_id" placeholder="">
				<label for="email_id">Email Id*</label>
			</div>
			<p *ngIf="showError('email_id')" class="text-danger">
				<span *ngIf="f.email_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.email_id.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.email_id.errors?.incorrect">
					{{customError.email_id}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="w-50 float-start">
				<ng-select appendTo="body" [items]="countries" bindLabel="display" bindValue="dial_code"
					[clearable]="true" [multiple]="false" id="countryCode" formControlName="countryCode"
					name="countryCode" placeholder="Country Code*" [appearance]="'outline'">
				</ng-select>
				<p *ngIf="showError('countryCode')" class="text-danger">
					<span *ngIf="f.countryCode.errors?.required">
						Required
					</span>
					<span *ngIf="f.countryCode.errors?.incorrect">
						{{customError.countryCode}}
					</span>
				</p>
			</div>
			<div class="w-50 float-start">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('phone_no')}" id="phone_no"
						formControlName="phone_no" placeholder="">
					<label for="phone_no">Phone No.*</label>
				</div>
				<p *ngIf="showError('phone_no')" class="text-danger">
					<span *ngIf="f.phone_no.errors?.required">
						Required
					</span>
					<span *ngIf="f.phone_no.errors?.pattern">
						Invalid
					</span>
					<span *ngIf="f.phone_no.errors?.incorrect">
						{{customError.phone_no}}
					</span>
				</p>
			</div>
		</div>
		<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('address')}" id="address"
					formControlName="address" placeholder=""></textarea>
				<label for="address">Address*</label>
			</div>
			<p *ngIf="showError('address')" class="text-danger">
				<span *ngIf="f.address.errors?.required">
					Required
				</span>
				<span *ngIf="f.address.errors?.incorrect">
					{{customError.address}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>